let _ = require('ES/lib/lodash');
let dd = require('ES/lib/dd');
let AuthedUserSession = require("../../../utils/AuthedUserSession");

module.exports = dd.createClass({
  render() {

    let decorators = [
      ['travel', 'travel'],
      ['daily', 'daily'],
      ['call', 'call'],

    ];

    if (AuthedUserSession.is_st_family) {
      decorators.push(['coaching', 'coaching']);
    }

    return dd.div({className: 'CalendarLegend text-center no-select', style: {padding: "1em 2em"}},
      dd.div({style: {paddingBottom: ".5em"}},
        dd.div({className: 'legend-item confirmedevent'}, 'confirmed'),
        dd.div({className: 'legend-item heldevent'}, 'held'),
        dd.div({className: 'legend-item leadevent'}, 'lead'),
        dd.div({className: 'legend-item postponedevent'}, 'postponed'),
        dd.div({className: 'legend-item closedevent'}, 'closed'),
        (!AuthedUserSession.is_st_family) && dd.div({},
          dd.div({className: "legend-item dayshape"}),
          dd.div({className: "legend-item dayshape-label"}, "on-site"),
          dd.div({className: "legend-item dayshape", style: {borderRadius: "4px"}}),
          dd.div({className: "legend-item dayshape-label"}, "remote")
        )
      ),
      _.map(decorators, function ([label, css_class], i) {
        return dd.div({key: i, className: 'legend-item decorator'},
          label,
          dd.span({className: css_class + ' decoration'})
        );
      })
    );
  }
});



// WEBPACK FOOTER //
// ./src/components/main_view/calendar_area/CalendarLegend.js